import { render, staticRenderFns } from "./PageResetPasswordError.vue?vue&type=template&id=c6ff038c"
import script from "./PageResetPasswordError.vue?vue&type=script&lang=js"
export * from "./PageResetPasswordError.vue?vue&type=script&lang=js"
import style0 from "./PageResetPasswordError.vue?vue&type=style&index=0&id=c6ff038c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports